<template>
  <main>
    <b-overlay :show="loading">
      <validation-observer ref="form">
        <b-card class="mb-2">
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Pilih Aset">
                <v-select
                  :options="barangOptions"
                  v-model="barang"
                  label="text"
                  placeholder="Cari / pilih aset..."
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <b-row>
          <b-col sm="12" md="6">
            <b-card>
              <h5 class="mb-1">Form penyimpanan kosong</h5>
              <p class="text-muted small mb-2">
                <template v-if="barang">
                  Aset dipilih: <strong>{{ barang.text }}</strong>
                </template>
                <template v-else>
                  Pilih aset di atas sebelum mengisi lokasi.
                </template>
              </p>

              <fieldset :disabled="!barang">
                <b-form-group v-if="myGudang">
                  <label for="">Pilih Gudang</label>
                  <b-form-input disabled :value="myGudang.nama_gudang" />
                </b-form-group>

                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="blok"
                    rules="required"
                  >
                    <label for="">Pilih Lokasi Aset <span class="text-danger">*</span></label>
                    <div class="d-flex align-items-start">
                      <v-select
                        class="flex-grow-1"
                        :options="bloks"
                        v-model="form.blok_id"
                        :required="!form.blok_id"
                        :reduce="(option) => option.value"
                        label="text"
                        placeholder="Pilih lokasi"
                      />
                      <b-button
                        class="ml-1 flex-shrink-0"
                        variant="outline-primary"
                        title="Tambah lokasi aset"
                        @click.prevent="openLokasiModal"
                      >
                        <feather-icon icon="PlusIcon" />
                      </b-button>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group class="mb-0">
                  <b-button variant="primary" @click.prevent="addBarang">
                    Tambah ke antrian
                  </b-button>
                </b-form-group>
              </fieldset>
            </b-card>
          </b-col>

          <b-col cols="12" class="mt-2">
            <b-card>
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <h5 class="mb-0">Antrian penyimpanan</h5>
                  <small class="text-muted">
                    {{ addedItems.length }} item siap disimpan
                  </small>
                </div>
                <b-button
                  variant="primary"
                  :disabled="!addedItems.length"
                  @click.prevent="submit"
                >
                  Simpan
                </b-button>
              </div>

              <div
                v-if="!addedItems.length"
                class="text-center text-muted py-4 border rounded"
              >
                Belum ada item di antrian. Isi form lalu klik
                <strong>Tambah ke antrian</strong>.
              </div>
              <b-table
                v-else
                :fields="fieldsAddedItems"
                bordered
                striped
                responsive
                :items="addedItems"
              >
                <template #cell(no)="row">
                  {{ row.index + 1 }}
                </template>
                <template #cell(lokasi)="{ item }">
                  <strong>{{ item.lokasi }}</strong>
                </template>
                <template #cell(action)="row">
                  <b-link
                    class="text-danger"
                    @click.prevent="addedItems.splice(row.index, 1)"
                  >
                    <feather-icon size="24" icon="XCircleIcon" />
                  </b-link>
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>

        <b-modal
          id="modal-tambah-lokasi-aset-empty"
          v-model="showLokasiModal"
          title="Tambah Lokasi Aset"
          centered
          @ok.prevent="submitLokasi"
          ok-title="Simpan"
          cancel-title="Batal"
        >
          <b-form-group label="Gudang Aset">
            <b-form-input
              disabled
              :value="myGudang ? myGudang.nama_gudang : ''"
            />
          </b-form-group>
          <b-form-group label="Nama Lokasi / Blok">
            <b-form-input
              v-model="lokasiForm.blok"
              placeholder="Nama lokasi"
              @keyup.enter.prevent="submitLokasi"
            />
          </b-form-group>
        </b-modal>
      </validation-observer>
    </b-overlay>
  </main>
</template>

<script>
import {
  BTable,
  BOverlay,
  BLink,
  BFormGroup,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormInput,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { extend } from "vee-validate";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("positive", (value) => {
  return value > 0;
});

export default {
  components: {
    vSelect,
    BLink,
    ValidationObserver,
    ValidationProvider,
    BOverlay,
    BFormGroup,
    BTable,
    BRow,
    BCol,
    BCard,
    BButton,
    BFormInput,
    BModal,
  },
  data: () => ({
    barang: null,
    barangOptions: [],
    loading: false,
    addedItems: [],
    fieldsAddedItems: [
      { key: "no", label: "No" },
      { key: "asset", label: "Nama Aset" },
      { key: "lokasi", label: "Lokasi" },
      { key: "action", label: "#" },
    ],
    bloks: [],
    form: {
      gudang_id: null,
      blok_id: null,
      jumlah: 0,
    },
    showLokasiModal: false,
    lokasiForm: {
      blok: "",
    },
  }),
  methods: {
    openLokasiModal() {
      this.lokasiForm.blok = "";
      this.showLokasiModal = true;
    },
    async submitLokasi() {
      const nama = (this.lokasiForm.blok || "").trim();
      if (!nama) {
        this.displayError({ message: "Nama lokasi tidak boleh kosong" });
        return;
      }
      if (!this.myGudang || !this.myGudang.id) {
        this.displayError({ message: "Gudang aset tidak ditemukan" });
        return;
      }

      this.loading = true;
      try {
        const created = await this.$store.dispatch("asset/saveBlok", [
          {
            gudang_id: this.myGudang.id,
            blok: nama,
          },
        ]);
        await this.getBlok();
        if (created && created.id) {
          this.form.blok_id = created.id;
        } else {
          const found = this.bloks.find((b) => b.text === nama);
          if (found) this.form.blok_id = found.value;
        }
        this.showLokasiModal = false;
        this.lokasiForm.blok = "";
        this.displaySuccess({ message: "Lokasi aset berhasil ditambahkan" });
      } catch (e) {
        this.displayError(e);
      } finally {
        this.loading = false;
      }
    },
    submit() {
      if (!this.addedItems.length) return;

      const payloads = this.addedItems.map((item) => ({
        gudang_id: this.myGudang.id,
        blok_id: item.blok_id,
        asset_id: item.asset_id,
      }));

      this.loading = true;
      this.$store
        .dispatch("asset/savePenyimpananEmpty", payloads)
        .then(() => {
          this.loading = false;
          this.displaySuccess({
            message: "Penyimpanan aset berhasil dibuat!",
          });

          setTimeout(() => {
            this.$router.push("/asset-penyimpanan");
          }, 1000);
        })
        .catch((e) => {
          this.loading = false;
          this.displayError(e);
          return false;
        });
    },
    addBarang() {
      if (!this.barang) {
        this.displayError({ message: "Pilih aset terlebih dahulu" });
        return;
      }
      this.$refs.form
        .validate()
        .then((success) => {
          if (success) {
            const data = {};
            Object.assign(data, this.form);
            data.asset = this.barang ? this.barang.text : null;
            data.asset_id = this.barang ? this.barang.value : null;

            const blok = this.bloks.find((b) => b.value == data.blok_id);
            data.lokasi = blok ? `Blok: ${blok.text}` : "";
            this.addedItems.push(data);
          }
        })
        .catch((e) => console.error(e));
    },
    async getBlok() {
      this.bloks = [];
      if (!this.myGudang) return;
      const bloks = await this.$store.dispatch("asset/getBlok", {
        gudang_id: this.myGudang.id,
      });
      this.bloks = bloks.map((blok) => ({ value: blok.id, text: blok.blok }));
    },
    async getBarang() {
      const params = {};
      if (this.myGudang) {
        params.gudang_id = this.myGudang.id;
      }

      const barangs = await this.$store.dispatch("asset/getBarang", params);
      this.barangOptions = (barangs.data || barangs || []).map((item) => ({
        value: item.id,
        text: item.nama,
      }));
    },
  },
  async created() {
    if (!this.myGudang) {
      this.$router.push("/asset-penyimpanan");
      return;
    }
    await this.getBarang();
    this.getBlok();
  },
};
</script>
